import { Injectable } from '@angular/core';
import { HttpErrorHandler, HandleError } from '@app/shared/services/http-error-handler.service';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { HeadersSetterHelper } from '@app/shared/helpers/http-headers-setter-helper';
import { Observable } from 'rxjs';
import { ISpringResponseBody, observeTypes } from '@app/shared/interfaces/response-interfaces';
import { AppConfig } from '@app/config/app.config';
import { catchError, map } from 'rxjs/operators';
import { ActionDevicesInitialize, ActionDevicesError } from './devices.reducer';

@Injectable()
export class DevicesService {
  private handleError: HandleError;
  private headerHelper: any;

  constructor(
    private httpErrorHandler: HttpErrorHandler,
    private http: HttpClient,
    private store: Store<any>
  ) {
    this.handleError = httpErrorHandler.createHandleError('DevicesService');
    this.headerHelper = new HeadersSetterHelper(this.store);
  }

  private getAll(): Observable<ISpringResponseBody | any> {
    return this.http.get<ISpringResponseBody>(
      AppConfig.endpoints.devices,
      this.headerHelper.options(observeTypes.BODY)
    ).pipe(
      catchError(this.handleError('getAll'))
    );
  }

  initAllDevices(): void {
    this.getAll().subscribe((response: ISpringResponseBody) => {
      if (response.status === 200) {
        this.store.dispatch(new ActionDevicesInitialize({ devices: response.data }));
      } else {
        this.store.dispatch(new ActionDevicesError({ response }));
      }
    });
  }

  /**
   * Прави POST заявка за добавяне на удостоверение към устройство.
   * При успех се връща Observable<string>, съдържащ QR код, който да се сканира от приложението.
   * @param certId
   */
  addDevice(certId: number): Observable<string | false> {
    return this.http.post<ISpringResponseBody>(
      AppConfig.endpoints.operations.addDevice, certId, this.headerHelper.options(observeTypes.BODY)
    ).pipe(
      catchError(this.handleError('addDevice')),
      map((res: ISpringResponseBody) => {
        if (res.status === 200) {
          return res.data;
        } else {
          return false;
        }
      })
    );
  }

  deleteDevice(deviceId: string): Observable<ISpringResponseBody> {
    return this.http.delete<ISpringResponseBody>(
      AppConfig.endpoints.devices + '/' + deviceId, this.headerHelper.options(observeTypes.BODY)
    ).pipe(
      catchError(this.handleError('deleteDevice')),
      map((res: ISpringResponseBody) => res)
    );
  }
  removeDeviceFromCertificate(deviceId: string, certReqId: string): Observable<ISpringResponseBody> {
    return this.http.delete<ISpringResponseBody>(
      AppConfig.endpoints.certificates + '/' + certReqId + '/device/' + deviceId + '/remove', this.headerHelper.options(observeTypes.BODY)
    ).pipe(
      catchError(this.handleError('removeDeviceFormCertificate')),
      map((res: ISpringResponseBody) => res)
    );
  }

  hold(certId: number): Observable<ISpringResponseBody | any> {
    return this.http.post<ISpringResponseBody>(
      AppConfig.endpoints.operations.hold, certId, this.headerHelper.options(observeTypes.BODY)
    ).pipe(
      catchError(this.handleError('hold'))
    );
  }

  restore(certId: number): Observable<ISpringResponseBody | any> {
    return this.http.post<ISpringResponseBody>(
      AppConfig.endpoints.operations.restore, certId, this.headerHelper.options(observeTypes.BODY)
    ).pipe(
      catchError(this.handleError('restore'))
    );
  }

}
